import React, { FC } from 'react';

import { useAuth, useLang, useModal } from 'hooks';
import { Button } from 'components/ui';
import { ProfileStatus } from 'types/models';
import { ButtonProps } from 'types/components';

import InvoiceModal from './InvoiceModal';

type InvoiceButtonProps = Omit<ButtonProps, 'onClick'>;

const InvoiceButton: FC<InvoiceButtonProps> = (props) => {
  const auth = useAuth();
  const lang = useLang();
  const modal = useModal();

  if (auth.status === ProfileStatus.SUSPENDED) {
    return null;
  }

  return (
    <>

      <Button onClick={modal.show} {...props}>
        {lang.get('common.menu.createInvoice')}
      </Button>

      <InvoiceModal
        open={modal.open}
        onCancel={modal.hide}
      />

    </>
  );
};

export default InvoiceButton;
